module.exports = __webpack_public_path__ + "img/2025-womens-retreat.535beb76.png";